import React from "react";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../components/forms/TextInput";
import SelectInput from "../../../components/forms/SelectInput";
import PhoneInputField from "../../../components/forms/PhoneInputField";
import RadioInput from "../../../components/forms/RadioInput";
import { validationMode, civiliteList } from "../../../config/helpers";

interface SectionDemandeurProps {
  isFonctionsLoading: boolean;
  fonctions: any;
}

const SectionDemandeur: React.FC<SectionDemandeurProps> = ({
  isFonctionsLoading,
  fonctions,
}) => {
  

  return (
    <CpntFormSection pSectionLabel="INFORMATIONS SUR LE DEMANDEUR (ADMINISTRATEUR DU COMPTE)">
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <RadioInput
          label="Civilité"
          formName="IdCivilite"
          ismandatory={true}
          options={civiliteList.map((civ) => {
            return {
              id: civ.Id,
              name: civ.Libelle,
              value: civ.Id,
            };
          })}
        />
      </CpntFormSectionContainer>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
        <TextInput
          label="Nom"
          formName="Nom"
          ismandatory={true}
          validationStyle={validationMode.classic}
          placeholder="Nom"
        />
        <TextInput
          label="Prénom"
          formName="Prenom"
          ismandatory={true}
          validationStyle={validationMode.classic}
          placeholder="Prénom"
        />
      </CpntFormSectionContainer>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
        <PhoneInputField
          label="Téléphone"
          formName="Telephone"
          placeholder="Numéro de téléphone"
          popover="Sélectionnez votre pays et saisissez votre numéro de téléphone."
        />
        <SelectInput
          label="Fonction"
          formName="Fonction"
          ismandatory={true}
          optionEmpty="Sélectionnez une fonction"
          validationStyle={validationMode.classic}
          options={isFonctionsLoading ? [] : (fonctions?.Fonctions || [])}
        />
      </CpntFormSectionContainer>
    </CpntFormSection>
  );
};

export default SectionDemandeur;
